import client from "./internal/httpClient";
import axios from "axios";
import { getToken } from "../utils/index";

// 获取模板列表
export function templateList() {
  return client.post("/admin/templateList");
}

// 添加模板
export function templateAdd(data) {
  return client.post("/admin/templateAdd", data);
}

// 更新模板
export function templateUpdate(data) {
  return client.post("/admin/templateUpdate", data);
}

// 删除模板
export function templateDelete(data) {
  return client.post("/admin/templateDelete", data);
}

// 上传模板图片
export function templateUploadImage(formData) {
  const APP_URL = process.env.VUE_APP_URL || "";
  return axios.post(`${APP_URL}/admin/templateUploadImage`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Token: getToken(),
    },
  }).then(res => res.data);
}
